/**
 * @generated SignedSource<<a5a1efbaf1526e8724dda4eee50f99e9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BankTransactionGroup = "CUSTOMER_PAYMENTS" | "FINANCING" | "OTHER" | "SALARIES" | "SUPPLIERS" | "TAX_OFFICE" | "TRANSFER" | "%future added value";
export type BillingCycle = "MONTHLY_IN_ADVANCE" | "MONTHLY_IN_ARREARS" | "ONE_TIME" | "QUARTERLY_IN_ADVANCE" | "YEARLY_IN_ADVANCE" | "%future added value";
export type ForecastCategory = "DEPRECIATION" | "FINANCING" | "INCOME_TAXES" | "OTHER" | "OTHER_OPERATING_INCOME" | "PERSONNEL" | "REVENUE" | "SUPPLIERS" | "%future added value";
export type PlannedItemEffect = "LIQUIDITY_ONLY" | "RESULT_AND_LIQUIDITY" | "RESULT_ONLY" | "%future added value";
export type PlannedItemRhythm = "MONTHLY" | "ONE_TIME" | "QUARTERLY" | "YEARLY" | "%future added value";
export type VatRate = "NONE" | "REDUCED" | "STANDARD" | "%future added value";
export type AnalysisForecastPlannedItemsViewQuery$variables = Record<PropertyKey, never>;
export type AnalysisForecastPlannedItemsViewQuery$data = {
  readonly plannedItems: ReadonlyArray<{
    readonly definition: {
      readonly category: ForecastCategory;
      readonly dayOfMonth: number;
      readonly effect: PlannedItemEffect;
      readonly endMonth: string | null | undefined;
      readonly liquidityGroup: BankTransactionGroup | null | undefined;
      readonly name: string;
      readonly netAmount: number;
      readonly rhythm: PlannedItemRhythm;
      readonly startMonth: string;
      readonly vatRate: VatRate;
    };
    readonly enabled: boolean;
    readonly id: string;
    readonly nextDueDate: any | null | undefined;
  }>;
  readonly subscriptionAmountOverrides: ReadonlyArray<{
    readonly id: string;
    readonly monthlyNetAmount: number;
    readonly note: string | null | undefined;
    readonly setAt: any;
    readonly setBy: string;
    readonly subscription: {
      readonly customerAccount: {
        readonly customerName: string;
        readonly id: string;
      };
      readonly id: string;
      readonly subscriptionServiceReferenceLabel: string | null | undefined;
    } | null | undefined;
  }>;
  readonly supplierAmountOverrides: ReadonlyArray<{
    readonly id: string;
    readonly netAmount: number;
    readonly note: string | null | undefined;
    readonly setAt: any;
    readonly setBy: string;
    readonly supplier: {
      readonly billingCycle: BillingCycle | null | undefined;
      readonly id: string;
      readonly name: string;
    } | null | undefined;
  }>;
};
export type AnalysisForecastPlannedItemsViewQuery = {
  response: AnalysisForecastPlannedItemsViewQuery$data;
  variables: AnalysisForecastPlannedItemsViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "netAmount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "note",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "setBy",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "setAt",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PlannedItem",
    "kind": "LinkedField",
    "name": "plannedItems",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enabled",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nextDueDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PlannedItemDefinition",
        "kind": "LinkedField",
        "name": "definition",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "category",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vatRate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rhythm",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startMonth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endMonth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dayOfMonth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "effect",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "liquidityGroup",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "SubscriptionAmountOverride",
    "kind": "LinkedField",
    "name": "subscriptionAmountOverrides",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "monthlyNetAmount",
        "storageKey": null
      },
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Subscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subscriptionServiceReferenceLabel",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomerAccount",
            "kind": "LinkedField",
            "name": "customerAccount",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customerName",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "SupplierAmountOverride",
    "kind": "LinkedField",
    "name": "supplierAmountOverrides",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Supplier",
        "kind": "LinkedField",
        "name": "supplier",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "billingCycle",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AnalysisForecastPlannedItemsViewQuery",
    "selections": (v6/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AnalysisForecastPlannedItemsViewQuery",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "b89556a474c7d2fc889d76150728eec8",
    "id": null,
    "metadata": {},
    "name": "AnalysisForecastPlannedItemsViewQuery",
    "operationKind": "query",
    "text": "query AnalysisForecastPlannedItemsViewQuery {\n  plannedItems {\n    id\n    enabled\n    nextDueDate\n    definition {\n      name\n      category\n      netAmount\n      vatRate\n      rhythm\n      startMonth\n      endMonth\n      dayOfMonth\n      effect\n      liquidityGroup\n    }\n  }\n  subscriptionAmountOverrides {\n    id\n    monthlyNetAmount\n    note\n    setBy\n    setAt\n    subscription {\n      id\n      subscriptionServiceReferenceLabel\n      customerAccount {\n        id\n        customerName\n      }\n    }\n  }\n  supplierAmountOverrides {\n    id\n    netAmount\n    note\n    setBy\n    setAt\n    supplier {\n      id\n      name\n      billingCycle\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b83612c874e69a5a3d176c7d7f8b3696";

export default node;
